import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { Plus, Minus } from 'lucide-react';
import { Section } from './ui/Section';
const faqs = [{
  question: '¿Necesito tener conocimientos previos de espiritualidad o metafísica?',
  answer: 'No. El ebook está diseñado para acompañarte desde cero. Cada capítulo explica los conceptos de forma clara y accesible, sin asumir conocimiento previo. Si ya conoces las enseñanzas de Neville Goddard, encontrarás una síntesis profunda y práctica que complementará tu camino.'
}, {
  question: '¿Cómo recibo el ebook después de la compra?',
  answer: 'Inmediatamente después de confirmar tu pago, recibirás un correo electrónico con el enlace de descarga del archivo PDF. El acceso es de por vida, así que puedes descargarlo cuando quieras y leerlo en cualquier dispositivo: celular, tablet o computadora.'
}, {
  question: '¿Cuánto tiempo debo dedicarle cada día?',
  answer: 'Cada capítulo diario está pensado para leerse en 10 a 15 minutos. Los ejercicios prácticos y las técnicas de SATS se realizan antes de dormir, por lo que no necesitas reorganizar tu día. Es espiritualidad que se adapta a tu vida real.'
}, {
  question: '¿Qué pasa si no veo resultados en los 30 días?',
  answer: 'La transformación es un proceso que comienza desde adentro. Muchos lectores reportan cambios en su diálogo interno y en su estado emocional desde la primera semana. Los resultados externos varían según cada persona, pero el trabajo de reprogramación del subconsciente es acumulativo: cada día que practicas, estás construyendo una nueva conciencia.'
}, {
  question: '¿Este ebook es solo para mujeres?',
  answer: 'Para nada. El poder del Yo Soy y la manifestación consciente no tienen género. El ebook está escrito en un lenguaje inclusivo y ha transformado la vida de personas de todas las identidades. Si resonás con la idea de que tu conciencia es la única fuerza creadora, este libro es para vos.'
}];
function FAQItem({
  question,
  answer,
  index
}: {
  question: string;
  answer: string;
  index: number;
}) {
  const [isOpen, setIsOpen] = useState(false);
  return <motion.div initial={{
    opacity: 0,
    y: 15
  }} whileInView={{
    opacity: 1,
    y: 0
  }} viewport={{
    once: true
  }} transition={{
    delay: index * 0.1
  }} className="border-b border-sage/20 last:border-0" data-id="element-28">
      <button onClick={() => setIsOpen(!isOpen)} className="w-full flex items-center justify-between py-6 text-left gap-4 group" data-id="element-29">
        <span className="text-lg font-heading font-semibold text-navy group-hover:text-sage-dark transition-colors duration-200" data-id="element-30">
          {question}
        </span>
        <span className="flex-shrink-0 w-8 h-8 rounded-full bg-sage/10 flex items-center justify-center text-sage-dark group-hover:bg-sage group-hover:text-white transition-all duration-200" data-id="element-31">
          {isOpen ? <Minus size={16} data-id="element-32" /> : <Plus size={16} data-id="element-33" />}
        </span>
      </button>

      <AnimatePresence initial={false} data-id="element-34">
        {isOpen && <motion.div initial={{
        height: 0,
        opacity: 0
      }} animate={{
        height: 'auto',
        opacity: 1
      }} exit={{
        height: 0,
        opacity: 0
      }} transition={{
        duration: 0.3,
        ease: 'easeInOut'
      }} className="overflow-hidden" data-id="element-35">
            <p className="pb-6 text-gray-600 leading-relaxed pr-12" data-id="element-36">{answer}</p>
          </motion.div>}
      </AnimatePresence>
    </motion.div>;
}
export function FAQSection() {
  return <div className="bg-white" data-id="element-37">
      <Section data-id="element-38">
        <div className="max-w-3xl mx-auto" data-id="element-39">
          <div className="text-center mb-12" data-id="element-40">
            <h2 className="text-3xl md:text-4xl font-heading font-bold text-navy mb-4" data-id="element-41">
              Preguntas Frecuentes
            </h2>
            <div className="w-16 h-1 bg-sage mx-auto rounded-full" data-id="element-42" />
          </div>

          <div className="bg-cream rounded-2xl px-6 md:px-10 py-2 border border-sage/10" data-id="element-43">
            {faqs.map((faq, index) => <FAQItem key={index} {...faq} index={index} data-id="element-44" />)}
          </div>
        </div>
      </Section>
    </div>;
}